import React from 'react';

import withLayout from '../../../hoc/with-layout';
import ViewUserController from './view-user.controller';

const ViewUserScreen: React.FC = () => {
  return <ViewUserController />;
};
export default withLayout(ViewUserScreen);
